// External libraries
import React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { CurrencyConversionOptions } from '@checkout/react-components';
import { css } from '@emotion/core';

// Internal modules
import { SectionHeading } from '@/components/Headings';
import { $logger, getContent, useMountLogging } from '@/lib';
import { getDisclosures, getIofDisclosure, getTotal } from './utils';
import { PROCESS_CURRENCY_CONVERSION_SELECTION } from './fpti';

const CurrencyConversion = props => {
  useMountLogging('CurrencyConversion');
  const conversionData = useStoreState(({ api }) => api.currencyConversionData);
  const selectedOption = useStoreState(
    ({ form }) => form.currencyConversionSelection,
  );
  const updateOption = useStoreActions(
    ({ form }) => form.updateCurrencyConversionSelection,
  );
  const { from: fromCurrency, to: toCurrency } = conversionData;
  const changeHandler = (event, selection) => {
    $logger.fpti(
      'conversion_selection_change',
      PROCESS_CURRENCY_CONVERSION_SELECTION(selection),
    );
    updateOption(selection);
  };

  return (
    <div>
      <SectionHeading styleOverrides={css({ margin: '18px 0' })}>
        {getContent('currencyConversion.header')}
      </SectionHeading>

      <CurrencyConversionOptions
        changeHandler={changeHandler}
        conversionOptions={[
          { label: fromCurrency.currencyCode, value: 'PAYPAL' },
          { label: toCurrency.currencyCode, value: 'VENDOR' },
        ]}
        disclosures={getDisclosures(conversionData)}
        selectedConversionOption={selectedOption}
        total={getTotal(selectedOption, conversionData)}
        {...getIofDisclosure()}
      />
    </div>
  );
};

export { CurrencyConversion };
